import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { Link } from "react-router-dom";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import bannerImage from "../../Images/Banner/library-banner.webp";
import Vision from "../../Images/commonimg/vision-library.webp";
import Mission from "../../Images/commonimg/mission-library.webp";
import libr1 from "../../Images/campus/lib-1.webp";
import ELibrary from "../../Images/campus/e-library.webp";
import EnquiryNow from "../common/EnquiryNow";

const Library = () => {
  const [modalShow2, setModalShow2] = useState(false);

  const libraryFacilities = [
    {
      iconClass: "ti ti-books",
      title: "Tensive Collection",
      description:
        "The library houses a vast collection of books, journals, and research papers across various disciplines.",
    },
    {
      iconClass: "ti ti-device-laptop",
      title: "Digital Resources",
      description:
        "Students have access to e-books, online journals, and databases, facilitating research.",
    },
    {
      iconClass: "ti ti-armchair-2",
      title: "STUDY Spaces",
      description:
        "Comfortable study areas, including individual carrels and group study rooms, are available.",
    },
    {
      iconClass: "ti ti-server-cog",
      title: "Koha Automation",
      description:
        "The library employs the Koha system for automation, streamlining cataloging, circulation, and other library functions.",
    },
  ];

  return (
    <React.Fragment>
      <title>Library at ISBM University – Books, e-Resources & Support</title>
      <meta
        name="description"
        content="ISBM University Library offers comprehensive support for research and learning with digital resources, quiet zones, and expert assistance."
      />
      <Topnav />
      <section
        className="section-hero-banner ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
        }}
      >
        <div className="banner-hero-overlay">
          <div className="container-xxl">
            <div className="section-hero-content">
              <h1>Campus Learning Hub</h1>
              <ol className="breadcrumb mt-3 text-center mb-0">
                <li className="breadcrumb-item">
                  <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active text-white"
                  aria-current="page"
                >
                  Library
                </li>
                <hr className="section-divider" />
              </ol>
            </div>
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <div className="vc-paragraphs mx-auto">
            <div className="text-center mb-5">
              <h2 className="section-title modern-title text-blue mt-3">
                A dynamic hub for research & innovation
              </h2>
            </div>
            <p>
              The ISBM University Library Department serves as
              <strong>
                {" "}
                a central hub for academic resources and support{" "}
              </strong>
              within the university community. ISBM University also has a School
              of Library and Information Science that focuses on information
              organization, management, access, and dissemination. The School
              offers
              <strong>
                {" "}
                Bachelor's and Master's degrees in Library and Information
                Science
              </strong>
              , preparing graduates for careers in the field.
            </p>
            <p>
              Key features include a diverse collection of books, journals, and
              research papers, alongside digital resources like e-books, online
              journals, and databases. The library provides various study
              spaces, including individual carrels and group rooms, as well as
              dedicated reading areas. Reference services and workshops on
              research skills and information literacy are also available. The
              library, which began operating in July 2020, uses{" "}
              <strong>
                the Koha Integrated Library Management System (ILMS){" "}
              </strong>
              for operations and user access.
            </p>
            <p className="m-0">
              The Library of college has been well equipped with the latest
              information technologies and web based information Resources,
              <strong>
                {" "}
                e-books and e-Journals search, OPAC, Web OPAC and Internet
                browsing
              </strong>{" "}
              as it is well connected through LAN/ BSNL 100mbps Fiber Optic
              Internet Connection. The Library maintains around more than one
              lake collections of books, reference book, thesis, and monograph,
              back volumes of journals, audio-visuals and e-resources.
            </p>
          </div>
        </div>
      </section>

      <section className="sports-facilities-section pb-100 sports-info-section ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-center text-white">
            Empowering Learning Through Premier Library Resources
          </h2>
          <h6 className="modern-subtitle text-center text-white">
            The Central Library offers a rich collection of physical and digital
            resources, study spaces, and efficient services through the Koha
            system to support academic and research needs.
          </h6>
          <div className="row">
            {libraryFacilities.map((facility, index) => (
              <div className="col-md-3 col-sm-6 col-12 mb-3 d-flex">
                <div
                  key={index}
                  className="sports-facility-card m-auto h-100 w-100"
                >
                  <div className="facility-icon">
                    <i
                      className={`${facility.iconClass} facility-icon-style`}
                    ></i>
                  </div>
                  <h3 className="facility-title">{facility.title}</h3>
                  <p className="facility-description">{facility.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="ptb-50">
        <div className="container-xxl">
          <h2 className="section-title modern-title text-blue mt-5 text-center">
            A Vision for Access, A Mission for Impact
          </h2>
          {/* Mission Row */}
          <Row className="align-items-center gx-5 mb-5">
            <Col lg={6} className="pe-lg-5">
              <div className="library-content">
                <h2 className="modern-title text-blue mb-3">
                  Mission Of Central Library
                </h2>
                <p className="library-text">
                  The main Mission of the Central Library of the college is to
                  provide excellent library service for the study, teaching and
                  research work of the college. To make it easy for use by
                  developing the collection of e-information sources along with
                  the traditional printed collection of the library and with its
                  help in the study, teaching and research work to make it
                  effective for intellectual development and creativity.
                </p>
              </div>
            </Col>
            <Col lg={6}>
              <div className="library-image-container">
                <img
                  src={Mission}
                  className="library-image rounded-3"
                  alt="Graduation cap placed on a stack of books"
                  loading="lazy"
                />
                <div className="image-frame"></div>
              </div>
            </Col>
          </Row>

          {/* Vision Row */}
          <Row className="align-items-center gx-5 flex-lg-row-reverse">
            <Col lg={6}>
              <div className="library-content">
                <h2 className="modern-title text-blue mb-3">
                  Vision of Central Library
                </h2>
                <p className="library-text">
                  The Central Library of the college promotes academic and
                  research by ensuring the availability of necessary text
                  materials to the entire academic community on their subject.
                  Provides new technologies and modern services for continuous
                  acquisition, processing and retrieval of information sources
                  to meet the information needs of students, professors and
                  researchers. Ensures remote access to information sources of
                  the library from outside the library as well as providing
                  adequate reading space and resources by fully furnishing the
                  library for the users.
                </p>
              </div>
            </Col>
            <Col lg={6} className="pe-lg-5">
              <div className="library-image-container">
                <img
                  src={Vision}
                  className="library-image rounded-3"
                  alt="Stack of books with a magnifying glass"
                  loading="lazy"
                />
                <div className="image-frame"></div>
              </div>
            </Col>
          </Row>
        </div>
      </section>

      <section
        className="hostel-gallery-section ptb-50"
        style={{
          backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${libr1})`,
        }}
      >
        <div className="container-xxl">
          <div className="text-center">
            <h2 className="section-title modern-title text-white">
              Empowering Minds Through Knowledge
            </h2>
            <p className="lead mb-4 text-white">
              Explore our vast library resources and unlock your academic
              potential.
            </p>
            <Row className="justify-content-center mb-4">
              <Col md={6}>
                <p className="text-white">
                  A university library typically offers a variety of events and
                  activities to engage students and promote its resources.
                </p>
              </Col>
            </Row>
            <div className="library-apply-btn">
              <button
                type="button"
                className="btn btn-purple px-4 py-2 rounded-pill fw-semibold "
                onClick={() => setModalShow2(true)}
              >
                Apply Now
              </button>
              <EnquiryNow
                show={modalShow2}
                onHide={() => setModalShow2(false)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="hostel-discipline-section ptb-50">
        <div className="container-xxl">
          <Row className="align-items-center">
            <div className="col-md-6 col-12 mb-3">
              <div className="discipline-image shadow-lg rounded overflow-hidden">
                <img src={ELibrary} alt="Books and laptop on study desk" className="img-fluid" />
              </div>
            </div>
            <div className="col-md-6 col-12">
              <div className="discipline-content">
                <h2 className="modern-title section-title-start text-blue">
                  Digital Library / e-Resources
                </h2>
                <p className="lead">
                  The Internet has transformed libraries, enabling faster,
                  smarter access to knowledge for teaching and research.
                </p>
                <p>
                  E-libraries offer instant access to academic content,
                  supporting modern learners and educators with flexible, remote
                  access to e-books, journals, and research tools—making them
                  essential to today’s teaching and learning
                </p>
                <ul className="list-unstyled">
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    comprehend the definition and importance of e- resources
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    categorize different types of e-resources
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    define e- books and e- journals;
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    understand the concept of electronic databases
                  </li>
                  <li className="mb-1">
                    <i className="ti ti-circle-check text-blue me-2"></i>
                    Distinguish between bibliographic and full text databases
                  </li>
                </ul>
              </div>
            </div>
          </Row>
        </div>
      </section>
      <Footer />
    </React.Fragment>
  );
};

export default Library;
